<template>
    <div id="app">
        <router-view name="header"/>
        <div>
            <router-view :key="$route.fullPath"/>
        </div>
        <router-view name="footer"/>
        
        <CookieBanner />
    </div>
</template>

<script>
// import CookieBanner from './pages/components/CookieBanner.vue';

export default {
    components: {
        // CookieBanner
    },
    methods: {
      cambiarFavicon(url) {
        const existingIcons = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']");
        existingIcons.forEach(icon => icon.parentNode.removeChild(icon));
        
        let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = `${url}?${new Date().getTime()}`; 
        document.getElementsByTagName('head').appendChild(link);
      
        let linkAppleIcon = document.querySelector("link[rel*='apple-touch-icon']") || document.createElement('link');
        linkAppleIcon.rel = 'apple-touch-icon';
        linkAppleIcon.href = url;
        document.getElementsByTagName('head').appendChild(linkAppleIcon);
      }    
    },
    mounted() {
      console.log("favicon: ",this.$store.state.ruta_favicon)
      this.cambiarFavicon(this.$store.state.ruta_favicon);
    }
}
</script>